var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "url(#pattern0)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10_2",
    transform: "scale(0.0166667)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_10_2",
    width: 60,
    height: 60,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8BAMAAADI0sRBAAAAAXNSR0IB2cksfwAAABhQTFRF////////////////////////////////KSvAyAAAAAh0Uk5TADfNHPH/3ODfgJPQAAAA90lEQVR4nIXVyw3CMAwGYKMsgFAX4MCdU+4cWABhOgBiBPYnTkqaxy//vaR1+7XNw46IyOkq4Ajn0h7ub3Q7Po+5XfQFePjorWBVwKNq5osq4AmrccOAR4smbnjmGRu/5HbksUQf/5Oebzih/WzGZgBvCeCdmHgPJj48P1yOjw/X08e6wPyrXQR0tAmhYWpicJBrEI7xziGufP3C+a0c48ox7jla2NHDLUe44TCnJGydWiFmt/2Xk1/zO0aGxR9UMiX+hJLl4C8mshT9hUzSwE8ikoJ+ApP094sHKT1+4SJljxRNUnJJwSblnmwWbKshGxXb5rxN8gdxHwoWBji2qQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtn);
export default __webpack_public_path__ + "static/media/Close_Btn.99b0f3662ee08b8eca9166cffebff5d3.svg";
export { ForwardRef as ReactComponent };